/**
 * HighContrastToggle — WCAG AAA high-contrast mode switch.
 *
 * @module components/accessibility/HighContrastToggle
 */
import React from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { Trans } from '@lingui/react/macro';
import { useAccessibilitySettings } from '../../hooks/useAccessibilitySettings';

export const HighContrastToggle: React.FC = () => {
  const { highContrast, prefersHighContrast, updateSettings } =
    useAccessibilitySettings();

  const handleToggle = () => {
    updateSettings({ highContrast: !highContrast });
  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={highContrast}
            onChange={handleToggle}
            inputProps={{ 'aria-label': 'High contrast mode' }}
          />
        }
        label={
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>High Contrast Mode</Trans>
            </Typography>
            <Typography variant="caption" sx={{ display: 'block', mt: 0.25 }} color="text.secondary">
              {highContrast ? (
                <Trans>WCAG AAA high contrast is active</Trans>
              ) : (
                <Trans>Standard contrast</Trans>
              )}
              {prefersHighContrast && (
                <>
                  {' '}
                  (<Trans>system preference</Trans>)
                </>
              )}
            </Typography>
          </Box>
        }
        sx={{ ml: 0, alignItems: 'flex-start' }}
      />
    </Box>
  );
};

export default HighContrastToggle;
